import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from "aws-amplify";
import { Card, Table, Spinner } from 'react-bootstrap';
import { ArrowRightShort } from 'react-bootstrap-icons';
import { parseAsMoment } from './../../../shared/utils/date'


/**
 * 有効／保守期限変更ライセンス（期間内 最新10件）のカード
 */
const MaintenanceChangesCard = ({ loading, totalCount, changes, limit = 10 }) => {
  const noData = !Array.isArray(changes) || changes.length === 0;

  const list = (changes || []).slice(0, limit);

  // ユーザ詳細ページへのリンク情報
  const goUserPage = (argUserId) => ({
    pathname: `/user/${argUserId}`
  });
  
  // ライセンス詳細ページへのリンク情報
  const goLicencePage = (argLicence, argUser) => ({
    pathname: `/licence/${argLicence}`,
    state: { userId: argUser },
  });

  const parseData = (arg) => {
    return parseAsMoment(arg).format('YYYY年MM月DD日')
  }

  const periodLabel = (p) => {
    if (p === 'perpetual') return I18n.get('constant_licence_period_perpetual');
    if (p === 'subscription') return I18n.get('constant_licence_period_subscription');
    return '-';
  };

  const renderDiffCell = (before, after) => {
    // 両方空ならハイフン
    if (!before && !after) return <span>-</span>;

    // 変更なしなら一行だけ表示
    if (before === after) {
      return <span>{before || '-'}</span>;
    }

    // 変更あり：2 行＋矢印
    return (
      <div className="diff-cell">
        <div className="diff-before text-muted small">
          {before || '-'}
        </div>
        <div className="diff-after">
          <ArrowRightShort className="me-1" />
          <span className="fw-bold">{after || '-'}</span>
        </div>
      </div>
    );
  };

  return (
    <Card>
      <Card.Header>
        <div>
          有効／保守期限変更ライセンス
          （期間内／合計 {totalCount} 件・最新 {limit} 件）
        </div>
        <div className="small text-muted mt-1 mt-md-0">
          ※ 同一ライセンスに対する複数回の変更は 1 件として集計しています。
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        {loading ? (
          <div className="text-center my-3">
            <Spinner
              as="span"
              animation="border"
              role="status"
              aria-hidden="true"
            />
          </div>
        ) : (
          <Table size="sm" hover responsive className="text-nowrap">
            <thead>
              <tr>
                <th>ユーザ名</th>
                <th>ライセンスID</th>
                <th>購入種別</th>
                <th>有効期限（前→後）</th>
                <th>保守期限（前→後）</th>
                <th>変更日</th>
              </tr>
            </thead>
            <tbody>
              {noData ? (
                <tr>
                  <td colSpan={6} className="text-muted text-center">
                    データがありません
                  </td>
                </tr>
              ) : (
                list.map((row) => (
                  <tr key={row.id}>
                    <td>
                        <Link 
                          to={goUserPage(row.userId)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {row.username}
                        </Link>{' '}
                    </td>
                    <td>
                        <Link
                          to={goLicencePage(row.licenceId, row.userId)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {row.licenceKey}
                        </Link>{' '}
                    </td>
                    <td>
                      {renderDiffCell(
                        periodLabel(row.beforePeriod),
                        periodLabel(row.afterPeriod)
                      )}
                    </td>
                    <td>
                      {renderDiffCell(
                        row.beforeSubscriptionExpiryDateAt,
                        row.afterSubscriptionExpiryDateAt
                      )}
                    </td>

                    <td>
                      {renderDiffCell(
                        row.beforeMaintenancePeriod,
                        row.afterMaintenancePeriod
                      )}
                    </td>
                    <td>
                      {row.changedAt
                        ? parseAsMoment(row.changedAt).format('YYYY年MM月DD日 HH:mm')
                        : ''}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default MaintenanceChangesCard;
